import { jsonProperty, Serializable } from "ts-serializable";
import VitalSignInstrument from "./VitalSignInstrument";

class VitalSign extends Serializable {

    @jsonProperty(String, null)
    id: string | null = null;

    @jsonProperty(String, null)
    nome: string | null = null;

    @jsonProperty(Boolean)
    inativo: boolean = false;

    @jsonProperty(Boolean)
    padrao: boolean = false;

    @jsonProperty(String, null)
    unidadePadrao: string | null = null;

    @jsonProperty(String, null)
    unidades: string | null = null;

    @jsonProperty([VitalSignInstrument])
    instrumentos: VitalSignInstrument[] = [];

    @jsonProperty(String, null)
    locais: string | null = null;

    @jsonProperty(String, null)
    tipoCampo: string | null = "numerico";

    @jsonProperty(String, null)
    mascara: string | null = null;

    @jsonProperty(String, null)
    formula: string | null = null;

    @jsonProperty(Number, null)
    ordem: number | null = null;
}

export default VitalSign;